import { render, staticRenderFns } from "./CircleAlertIcon.vue?vue&type=template&id=65a058c2&"
import script from "./CircleAlertIcon.vue?vue&type=script&lang=js&"
export * from "./CircleAlertIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports